var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gold-beans-container", class: { mobile: _vm.isMobile } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showRecordsView,
              expression: "!showRecordsView",
            },
          ],
          staticClass: "gold-beans-toolbar",
        },
        [
          _c(
            "div",
            {
              staticClass: "record-entry",
              on: {
                click: function ($event) {
                  return _vm.openRecordsView("game")
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../jollybeans/assets/Image14.png"),
                  alt: "游戏记录",
                },
              }),
              _c("span", [_vm._v("游戏记录")]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "record-entry",
              on: {
                click: function ($event) {
                  return _vm.openRecordsView("balance")
                },
              },
            },
            [
              _c("img", {
                attrs: {
                  src: require("../jollybeans/assets/Image15.png"),
                  alt: "余额记录",
                },
              }),
              _c("span", [_vm._v("余额记录")]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRecordsView,
              expression: "showRecordsView",
            },
          ],
          staticClass: "records-view",
        },
        [
          _c("div", { staticClass: "records-view-header" }, [
            _c("span", {
              staticClass: "records-view-back el-icon-arrow-left",
              on: {
                click: function ($event) {
                  _vm.showRecordsView = false
                },
              },
            }),
            _c("div", { staticClass: "records-view-tabs" }, [
              _c(
                "span",
                {
                  staticClass: "records-tab",
                  class: { active: _vm.recordTab === "game" },
                  on: {
                    click: function ($event) {
                      _vm.recordTab = "game"
                    },
                  },
                },
                [_vm._v("游戏记录")]
              ),
              _c(
                "span",
                {
                  staticClass: "records-tab",
                  class: { active: _vm.recordTab === "balance" },
                  on: {
                    click: function ($event) {
                      _vm.recordTab = "balance"
                    },
                  },
                },
                [_vm._v("余额记录")]
              ),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.recordTab === "game",
                  expression: "recordTab === 'game'",
                },
              ],
              staticClass: "records-body",
            },
            [
              _vm.recordsLoading && !_vm.gameRecords.length
                ? _c("div", { staticClass: "records-empty" }, [
                    _vm._v("加载中..."),
                  ])
                : !_vm.gameRecords.length
                ? _c("div", { staticClass: "records-empty" }, [
                    _vm._v("暂无游戏记录"),
                  ])
                : _c(
                    "div",
                    { staticClass: "records-grid" },
                    _vm._l(_vm.gameRecords, function (row) {
                      return _c(
                        "div",
                        { key: "game-" + row.id, staticClass: "record-card" },
                        [
                          _c("div", [
                            _c("span", [_vm._v("游戏：")]),
                            _vm._v(_vm._s(row.reason)),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("金额：")]),
                            _vm._v(_vm._s(row.amount)),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("余额：")]),
                            _vm._v(_vm._s(row.balance)),
                          ]),
                          _c("div", [
                            _c("span", [_vm._v("时间：")]),
                            _vm._v(_vm._s(row.time)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.recordTab === "balance",
                  expression: "recordTab === 'balance'",
                },
              ],
              staticClass: "records-body",
            },
            [
              _vm.recordsLoading && !_vm.records.length
                ? _c("div", { staticClass: "records-empty" }, [
                    _vm._v("加载中..."),
                  ])
                : !_vm.records.length
                ? _c("div", { staticClass: "records-empty" }, [
                    _vm._v("暂无余额记录"),
                  ])
                : _c("table", { staticClass: "records-table" }, [
                    _vm._m(0),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (row) {
                        return _c("tr", { key: "balance-" + row.id }, [
                          _c("td", [_vm._v(_vm._s(row.typeName))]),
                          _c(
                            "td",
                            {
                              class: {
                                positive: row.amount > 0,
                                negative: row.amount < 0,
                              },
                            },
                            [_vm._v(_vm._s(row.amount))]
                          ),
                          _c("td", [_vm._v(_vm._s(row.balance))]),
                          _c("td", [_vm._v(_vm._s(row.time))]),
                        ])
                      }),
                      0
                    ),
                  ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showRecordsView,
              expression: "!showRecordsView",
            },
          ],
          staticClass: "game-list",
        },
        [
          _vm._l(_vm.gameList, function (game, index) {
            return [
              !game.flag || _vm.$canShowFeature(game.flag)
                ? _c(
                    "div",
                    {
                      staticClass: "game-item",
                      style: { backgroundImage: "url(" + game.src + ")" },
                      attrs: { id: index },
                      on: {
                        click: function ($event) {
                          return _vm.goToGame(game.route)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "game-title" }, [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(game.name)),
                        ]),
                        _c("div", { staticClass: "icon_jd" }),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("类型")]),
        _c("th", [_vm._v("金额")]),
        _c("th", [_vm._v("余额")]),
        _c("th", [_vm._v("时间")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }